function WorkOrderPlanIcon(props) {
  const { isActive } = props
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.66667 0.666656H11.3333V1.99999H14V7.33332H12.6667V3.33332H11.3333V4.66666H4.66667V3.33332H3.33333V14H7.33333V15.3333H2V1.99999H4.66667V0.666656ZM6 3.33332H10V1.99999H6V3.33332Z"
        fill={!isActive ? '#828282' : '#FFFFFF'}
      />
      <path
        d="M12 9.66668C11.3812 9.66668 10.7877 9.91251 10.3501 10.3501C9.9125 10.7877 9.66667 11.3812 9.66667 12C9.66667 12.6188 9.9125 13.2123 10.3501 13.6499C10.7877 14.0875 11.3812 14.3333 12 14.3333C12.6188 14.3333 13.2123 14.0875 13.6499 13.6499C14.0875 13.2123 14.3333 12.6188 14.3333 12C14.3333 11.3812 14.0875 10.7877 13.6499 10.3501C13.2123 9.91251 12.6188 9.66668 12 9.66668ZM8.33333 12C8.33333 11.5185 8.42817 11.0417 8.61244 10.5968C8.79671 10.152 9.06679 9.74777 9.40727 9.40729C9.74776 9.0668 10.152 8.79672 10.5968 8.61245C11.0417 8.42818 11.5185 8.33334 12 8.33334C12.4815 8.33334 12.9583 8.42818 13.4032 8.61245C13.848 8.79672 14.2522 9.0668 14.5927 9.40729C14.9332 9.74777 15.2033 10.152 15.3876 10.5968C15.5718 11.0417 15.6667 11.5185 15.6667 12C15.6667 12.9725 15.2804 13.9051 14.5927 14.5927C13.9051 15.2804 12.9725 15.6667 12 15.6667C11.0275 15.6667 10.0949 15.2804 9.40727 14.5927C8.71964 13.9051 8.33333 12.9725 8.33333 12ZM12.6667 10.5013V11.724L13.6093 12.6667L12.6667 13.6093L11.3333 12.276V10.5013H12.6667Z"
        fill={!isActive ? '#828282' : '#FFFFFF'}
      />
    </svg>
  )
}

export default WorkOrderPlanIcon
